import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './menu.css';

const MenuComponent = ({
    className = '',
    children,
    componentRef,
    place = 'right',
    directiron = 'down'
}) => (
    <ul
        className={classNames(
            styles.menu,
            className,
            {
                [styles.left]: place === 'left',
                [styles.right]: place === 'right',
                [styles.up]: directiron === 'up'
            }
        )}
        ref={componentRef}
    >
        {children}
    </ul>
);

MenuComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    componentRef: PropTypes.func,
    place: PropTypes.oneOf(['left', 'right']),
    directiron: PropTypes.oneOf(['down', 'up'])
};


const MenuItem = ({
    children,
    className,
    bottomLine = false,
    onClick,
    onMouseDown,
    shortcut,
    arrow
}) => (
    <li
        className={classNames(
            styles.menuItem,
            styles.hoverable,
            className,
            {[styles.menuSectionBottomLine]: bottomLine === true}
        )}
        onClick={onClick}
        onMouseDown={onMouseDown}
    >
        {(shortcut || arrow) ? (
            <span className={styles.menuItemRow}>
                <span>{children}</span>
                <span className={styles.menuItemShortcut}>{arrow ? '▶' : shortcut}</span>
            </span>
        ) : children}
    </li>
);

MenuItem.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    bottomLine: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    shortcut: PropTypes.string,
    arrow: PropTypes.bool
};


const addDividerClassToFirstChild = (child, id) => (
    child && React.cloneElement(child, {
        className: classNames(
            child.className,
            {[styles.menuSection]: id === 0}
        ),
        key: id
    })
);

const MenuSection = ({children}) => (
    <React.Fragment>{
        React.Children.map(children, addDividerClassToFirstChild)
    }</React.Fragment>
);

MenuSection.propTypes = {
    children: PropTypes.node
};

const SubMenu = ({label, children}) => (
    <li className={classNames(styles.menuItem, styles.hoverable, styles.subMenuContainer)}>
        <span className={styles.menuItemRow}>
            <span>{label}</span>
            <span className={styles.menuItemShortcut}>{'▶'}</span>
        </span>
        <ul className={styles.subMenu}>
            {children}
        </ul>
    </li>
);

SubMenu.propTypes = {
    label: PropTypes.node,
    children: PropTypes.node
};

export {
    MenuComponent as default,
    MenuItem,
    MenuSection,
    SubMenu
};
